import './App.css';

function Privacy() {
  return (
    <div className="App">
      <div className="App-header" style={{ 
        padding: '2rem', 
        fontSize: '0.9rem', 
        alignItems: 'flex-start',
        maxWidth: '100%'
      }}>
        <div style={{ width: '100%' }}>
          <h1 style={{ textAlign: 'center' }}>Privacy Policy</h1>
          <p style={{ textAlign: 'center', marginBottom: '2rem' }}>Last Updated: December 9, 2025</p>
        </div>
        
        <div style={{ maxWidth: '900px', textAlign: 'left', width: '100%' }}>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2>1. Introduction</h2>
          <p>
            TAPP Group ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
            explains how we collect, use, and safeguard information when you use our Shopify extensions.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>2. Information We Collect</h2>
          <p>Our Shopify extensions may collect the following types of information:</p>
          <ul>
            <li><strong>Store Information:</strong> Store name, domain, and basic store settings</li>
            <li><strong>Usage Data:</strong> How you interact with our extensions</li>
            <li><strong>Customer Interaction Data:</strong> Anonymous data about how customers use extension features</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and maintain our extension services</li>
            <li>Improve and optimize extension functionality</li>
            <li>Provide customer support</li>
            <li>Send important updates about our extensions</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>4. Data Storage and Security</h2>
          <p>
            We implement appropriate security measures to protect your information. Data is stored securely 
            and access is limited to authorized personnel only. We do not sell or share your personal 
            information with third parties for marketing purposes.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>5. Third-Party Services</h2>
          <p>
            Our extensions operate within the Shopify platform and are subject to Shopify's Terms of Service 
            and Privacy Policy. We recommend reviewing Shopify's privacy practices as well.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the information we have about your store</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Uninstall our extensions at any time</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>7. Data Retention</h2>
          <p>
            We retain your data only for as long as necessary to provide our services. When you uninstall 
            our extension, we will delete your data within 30 days unless required by law to retain it longer.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>8. Children's Privacy</h2>
          <p>
            Our extensions are not intended for use by children under 13 years of age. We do not knowingly 
            collect personal information from children.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by 
            updating the "Last Updated" date at the top of this policy.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us 
            through the Shopify App Store or your store's support channels.
          </p>
        </section>

        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem', width: '100%' }}>
          <a href="/" style={{ color: '#61dafb', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
